<!-- Panel de notificaciones -->
<div class="fixed inset-0 z-50" (click)="onClose.emit()">
  <div class="absolute top-16 right-4 md:right-10 w-80 md:w-96 bg-white dark:bg-crayola-blue-800 rounded-xl shadow-2xl border border-dark-khaki-200 dark:border-vivid-royal-700 overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-3 border-b border-dark-khaki-200 dark:border-vivid-royal-700">
      <h3 class="text-sm font-semibold text-vivid-royal-800 dark:text-white">Notificaciones</h3>
      <button pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm" (click)="onClose.emit()"></button>
    </div>

    <!-- Lista -->
    <div class="max-h-80 overflow-y-auto">
      @if(notifications.length === 0) {
        <div class="py-8 text-center">
          <i class="pi pi-bell-slash text-2xl text-vivid-royal-300 mb-2 block"></i>
          <p class="text-sm text-vivid-royal-400">Sin notificaciones</p>
        </div>
      } @else {
        @for(item of notifications; track $index) {
          <div class="px-4 py-3 hover:bg-vivid-royal-50 dark:hover:bg-vivid-royal-900 cursor-pointer border-b border-dark-khaki-100 dark:border-vivid-royal-700 last:border-0 transition-colors"
            (click)="showInfoNotification(item)">
            <p class="text-sm font-semibold text-vivid-royal-800 dark:text-white truncate">{{ item.title }}</p>
            @if(item.description?.trim()) {
              <p class="text-xs text-vivid-royal-400 mt-0.5 line-clamp-2">{{ item.description }}</p>
            }
          </div>
        }
      }
    </div>
  </div>
</div>

<!-- Detalle de notificación -->
<p-dialog header="{{ selectedNotification.title }}" [(visible)]="showDetail" [modal]="true" [style]="{width: '28rem'}">
  <p class="text-sm text-vivid-royal-700 dark:text-dark-khaki-50 whitespace-pre-line">{{ selectedNotification.description }}</p>
  <ng-template #footer>
    <button pButton label="Cerrar" class="p-button-sm p-button-outlined" (click)="showDetail=false"></button>
  </ng-template>
</p-dialog>
